import React from 'react';
import {
    AccountPanel,
    NotificationPanel,
    GradesPanel,
    ChatPanel,
    CommentsPanel,
    RssFeedPanel,
    AgendaPanel,
} from './SidebarPanels';

export function SlideOutMenu() {
    return (
        <React.Fragment>
            <AccountPanel />
            <NotificationPanel />
            <GradesPanel />
            <ChatPanel />
            <CommentsPanel />
            <RssFeedPanel />
            <AgendaPanel />
        </React.Fragment>
    );
}
